import { useTranslation } from "react-i18next"
import { InfiniteSelect, InfiniteSelectProps } from "./InfiniteSelect"
import { useDefaultInfiniteQuery } from "@/utils/useDefaultInfiniteQuery"
import { useDebouncedValue } from "@mantine/hooks"
import {
  SimpleUserWithPersonAndEmailInfoPagination,
  UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams,
} from "@/orval/gen/model"
import { InfiniteData } from "@tanstack/react-query"
import { userGetPaginatedSimpleUsersWithPersonAndEmailInfo } from "@/orval/gen"

interface Props
  extends Omit<
    InfiniteSelectProps<
      | InfiniteData<SimpleUserWithPersonAndEmailInfoPagination, unknown>
      | undefined
    >,
    "queryResult" | "mapDataToOption"
  > {
  filterOptions?: Omit<
    UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams,
    "pageRequest"
  >
}
export function InfiniteUserSelect({ filterOptions, ...props }: Props) {
  const [search, setSearch] = React.useState("")
  const [debouncedSearch] = useDebouncedValue(search, 200)
  const queryResult = useDefaultInfiniteQuery(
    userGetPaginatedSimpleUsersWithPersonAndEmailInfo,
    (pageRequest) => ({
      ...pageRequest,
      searchString: debouncedSearch,
      ...filterOptions,
    }),
    { pageSize: 25 }
  )

  const { t } = useTranslation("app_server")
  return (
    <InfiniteSelect
      queryResult={queryResult}
      mapDataToOption={(data) =>
        data?.pages
          .flatMap((p) => p.data)
          .map((u) => ({
            label: u.person?.name ?? u.userName,
            value: u.userId.toString(),
          }))
      }
      searchable
      placeholder={t("Search") + "..."}
      searchValue={search}
      onSearchChange={(v) => setSearch(v)}
      {...props}
    />
  )
}
